import React from "react";
import { useForm, Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { Actions as GROUPACTIONS } from "../../../store/actions/groupActions";
import { format } from "date-fns";
import { TrashIcon, XMarkIcon } from "@heroicons/react/20/solid";
import Spinner from "../../common/Spinner";

const DeleteGroupModal = ({ group, deleteGroup, closeModal, modalStatus, deleting }) => {
	if (!modalStatus) {
		return null;
	}

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{
				display: "block",
				background: "rgba(0,0,0,0.4)",
				overflow: "auto",
			}}
		>
			<div
				className="modal-dialog"
				style={{ width: "30%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">Confirm Deletion of Group</h3>
						</div>
						<div
							className="block-content"
							style={{ paddingRight: 0, paddingTop: 0, paddingBottom: 0 }}
						>
							<div className="tab-pane active content">
								Are you sure you want to delete this group?
								<br />
								<b>Note: You must contact support to restore this group in the future</b>
							</div>
						</div>
						<div className="block-content">
							<div
								className="block buttons"
								style={{
									marginRight: "1em",
									textAlign: "right",
									marginBottom: "9em",
								}}
							>
								<button
									className="btn btn-danger pull-right"
									type="submit"
									onClick={() => deleteGroup(group.id)}
								>
									{deleting ? (
										<>
											<Spinner
												style={{ height: "1.5em", verticalAlign: "middle", float: "left" }}
												className="animate-spin -ml-1 mr-3 h-5 w-5 "
											/>
											<div style={{ float: "left" }}> Deleting </div>
										</>
									) : (
										<>
											<TrashIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
											<div style={{ float: "left" }}> Delete </div>
										</>
									)}
								</button>

								<div className="clearfix"></div>
							</div>
						</div>
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { deleteGroupModal } = state?.pensions?.group;

	return {
		group: deleteGroupModal?.group,
		modalStatus: deleteGroupModal?.show,
		deleting: deleteGroupModal?.deleting,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(GROUPACTIONS.deleteGroupModal(false)),
	deleteGroup: (groupId) => dispatch(GROUPACTIONS.deleteGroup(groupId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteGroupModal);
